import React from "react"
// react hook form
import { Controller } from "react-hook-form"
// react phone input
import "react-phone-input-2/lib/style.css"
// components
import { InputWithLabel } from "@components/Form"
import { MailIcon } from "@assets/icons"
import PhoneInput from "react-phone-input-2"
// assets

export const IndividualInfo = ({ control, errors }) => {
  return (
    <>
      <div className="w-full md:max-w-[20.12rem] gap-4 flex flex-col bg-[--pure-white] p-4 md:p-0 rounded-2xl border border-[--border-theme-300] md:border-0">
        <h2 className="text-xs font-medium text-[--text-light-gray]">
          INDIVIDUAL INFO
        </h2>
        <div className="flex justify-between gap-3 md:gap-5">
          {/* First Name */}
          <InputWithLabel
            label="First Name"
            name="firstName"
            rules={{
              required: "First name is required",
              pattern: {
                value: /^[a-zA-Z0-9]*$/,
                message: "First name must be alphanumeric",
              },
              minLength: {
                value: 1,
                message: "First name must be at least 1 character",
              },
              maxLength: {
                value: 30,
                message: "First name must be at most 30 characters",
              },
            }}
            placeholder="First Name"
            control={control}
            errors={errors}
            containerClassName="w-1/2"
            isRequired
          />
          {/* Last Name */}
          <InputWithLabel
            label="Last Name"
            name="lastName"
            rules={{
              required: "Last name is required",
              pattern: {
                value: /^[a-zA-Z0-9]*$/,
                message: "Last name must be alphanumeric",
              },
              minLength: {
                value: 1,
                message: "Last name must be at least 1 character",
              },
              maxLength: {
                value: 30,
                message: "Last name must be at most 30 characters",
              },
            }}
            placeholder="Last Name"
            control={control}
            errors={errors}
            containerClassName="w-1/2"
            isRequired
          />
        </div>

        {/* Email */}
        <InputWithLabel
          label="Email"
          name="email"
          rules={{
            required: "Email is required",
          }}
          icon={
            <MailIcon className="absolute left-3.5 h-5 w-5 text-[var(--text-secondary)]" />
          }
          placeholder="johndoe@gmail.com"
          control={control}
          errors={errors}
          inputClassName="!pl-10"
          isRequired
          type="email"
        />

        <InputWithLabel
          label="Contact"
          name="contact"
          rules={{
            required: "Contact is required",
          }}
          placeholder="0000000000"
          control={control}
          errors={errors}
          customInput={
            <Controller
              control={control}
              name="contact"
              rules={{
                required: "Contact is required",
              }}
              render={({ field: { value, onChange } }) => (
                <PhoneInput
                  country={"us"}
                  value={value}
                  onChange={onChange}
                  autoFormat
                  inputProps={{
                    placeholder: "0000000000",
                    className: `h-11 !w-full !pl-12 focus:outline-none rounded-lg border border-[--primary-blue] ${errors.contact ? "border-[var(--border-error)]" : ""} focus:border-[--primary-blue]`,
                  }}
                  buttonClass="!bg-white !border-none !rounded-lg !top-1.5 !bottom-1.5 !left-1"
                  containerStyle={{
                    width: "100%",
                    border: "none",
                  }}
                  inputStyle={{
                    borderRadius: "8px",
                  }}
                />
              )}
            />
          }
          isRequired
        />
      </div>
    </>
  )
}

export default IndividualInfo
